import { render, staticRenderFns } from "./terms.vue?vue&type=template&id=5d87f8b8"
import script from "./terms.ts?vue&type=script&lang=js&external"
export * from "./terms.ts?vue&type=script&lang=js&external"
import style0 from "./terms.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports